import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs font-medium text-background-50 ${
            comic.status === '已完结' ? 'bg-accent-500' : 'bg-primary-500'
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {comic.title}
        </h3>
        <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-500">
          <span>{comic.genre} · {comic.chapters}话</span>
          <span>{comic.author}</span>
        </div>
      </div>
    </Link>
  );
}